import React from 'react'
import { ICalculatorHeader } from '../../../types'

const CalculatorHeader: React.FC<ICalculatorHeader> = ({header, logo}) => {

  return (
    <header className="calculator__header">
          <div className="calculator__header__inner">
            <div className="calculator__header__logo">
              <img src={logo} alt={header} />
            </div>
            <div className="calculator__header__text">
                { header }
            </div>
          </div>
        </header>
  );
}

export default CalculatorHeader
